import { Space } from 'antd';
import { useActivationHashPage } from '../../ActivationHashPage.context';
import ActivationForm from '../ActivationForm';
import ActivationHeader from '../ActivationHeader';
import ActivationResult from '../ActivationResult';
import ActivationWorkshopInfo from '../ActivationWorkshopInfo';

export default function ActivationContent() {
  const { blockReason, isTokenLoading } = useActivationHashPage();

  if (isTokenLoading || blockReason) {
    return <ActivationResult />;
  }

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <ActivationHeader />
      <ActivationWorkshopInfo />
      <ActivationForm />
    </Space>
  );
}
